<div class="container pb-3 hide-print" *ngIf="!loadingModal">
  <div class="row c-p bg-warning mb-3 p-1">
    <div class="col">
      <h6 class="my-2">{{ "RACES.BETTING_SLIP" | translate }} {{ coupon.betSlipId }}</h6>
    </div>
    <div class="col-auto mt-1">
      <button class="btn btn-link close" (click)="ref.close()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
  <div class="px-1 px-md-3">
    <div class="row mb-2">
      <div class="col-4 col-md-3">{{ "RACES.PLACE_BET" | translate }}</div>
      <div class="col-8 col-md-9">
        <strong>{{ coupon?.createdAt | date: "dd-MM-yyyy - HH:mm:ss" || '-' }} </strong>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-4 col-md-3">{{ "RACES.RACE_LOCATION" | translate }}</div>
      <div class="col">
        <strong>{{raceDetail.Track}}</strong>
      </div>
      <div class="w-100 d-sm-none mb-2"></div>
      <div class="col-4 col-md-3">{{ "RACES.RACE" | translate }}</div>
      <div class="col col-md">
        <strong>
          {{ "RACES.RACE_NR" | translate }} {{betSlip.raceIndex}}
        </strong>
      </div>
    </div>

    <div class="row border-top py-2 mt-2"
      *ngIf="coupon.status !== 'open' && coupon.status !== 'cancel' && coupon.status !== 'refund'">
      <div class="col-4 col-md-3">{{ "RACES.FINISH" | translate }}</div>
      <div class="col">
        <span *ngFor="let winner of winners; let isLast=last">
          <strong>
            {{ winner.programNumber}} {{winner.runnerName}} {{isLast ? '':'-'}}
          </strong>
        </span>
      </div>
    </div>

    <div class="row border-top pt-2 mb-2">
      <div class="col-4 col-md-3">{{ "RACES.BET" | translate }}</div>
      <div class="col">
        <strong>{{betSlip.bet | bettingType:betSlip?.raceCountry | translate | capitalizeFirst}}</strong>
      </div>
      <div class="w-100 d-sm-none mb-2"></div>
      <div class="col-4 col-md-3">{{ "RACES.BETTING_SLIP" | translate }}</div>
      <div class="col">
        <strong style="word-wrap:break-all">{{ coupon.betSlipId }}</strong>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-4 col-md-3">{{ "RACES.TYPE_OF_BET" | translate }}</div>
      <div class="col">
        <strong>{{ betSlip.betType | betType | translate}}</strong>
      </div>
      <div class="w-100 d-sm-none mb-2"></div>
      <div class="col-4 col-md-3">{{ "RACES.STATUS" | translate }}</div>

      <div class="col">
        <strong [ngClass]="{
            'text-success': coupon.status === 'won',
            'text-warning': coupon.status === 'open',
            'text-danger': coupon.status === 'lost',
            'text-secondary': coupon.status === 'refund',
            'text-muted': coupon.status === 'cancel'}">
          {{ "RACES." + coupon.status | uppercase | translate }}
        </strong>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-4 col-md-3">{{ "RACES.STAKES" | translate }}</div>
      <div class="col">
        <strong>{{ (betSlip.totalPrice * 1) / (betSlip.stake * 1) }} x
          {{ betSlip.stake * 1 | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</strong>
      </div>
    </div>

    <div class="row" *ngFor="let betItem of betSlip.bets;let i = index">
      <div class="col-4 col-md-3">
        <strong *ngIf="!(i>0&&betSlip.bets[i]?.runnerOrder===betSlip.bets[i-1]?.runnerOrder)">
          {{betItem.runnerOrder | betRank:betSlip}}
        </strong>
      </div>
      <div class="col">
        <div *ngIf="betSlip.betType === 'fo'">

          <strong *ngIf="betSlip.bet === 'win' ">
            {{ betItem.runnerProgramNumber }} - {{ betItem.RunnerName }}
            (win :{{betItem.winOdd}})</strong>

          <strong *ngIf="betSlip.bet === 'win_show' ">
            {{ betItem.runnerProgramNumber }} - {{ betItem.RunnerName }}
            (win : {{betItem.winOdd}} - place : {{betItem.showOdd}})
          </strong>

        </div>

        <div *ngIf="betSlip.betType !== 'fo'">
          <strong *ngIf=" betSlip.bet!=='win_show' ">
            {{ betItem.runnerProgramNumber }} - {{ betItem.RunnerName }}</strong>
          <strong *ngIf=" betSlip.bet==='win_show' ">{{ betItem.runnerProgramNumber }} - {{
            betItem.RunnerName}}</strong>
        </div>

      </div>
    </div>

    <div class="row border-top py-2 mt-2">
      <div class="col-4 col-md-3">{{ "RACES.TOTAL" | translate }}</div>
      <div class="col">
        <strong> {{ betSlip.totalPrice | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}
        </strong>
      </div>
    </div>

    <div class="row border-top py-2 mt-2" *ngIf="coupon.status === 'cancel' && coupon.cancelReason.trim() !== '' && coupon.cancelReason !== null">
      <div class="col-4 col-md-3">{{ "RACES.CANCELREASON" | translate }}</div>
      <div class="col">
        <strong> {{ coupon.cancelReason }}
        </strong>
      </div>
    </div>

    <div *ngIf="betSlip && betSlip.winnings && betSlip.winnings !== 0" class="row">
      <div class="col-4 col-md-3">{{ "RACES.WINNINGS" | translate }}</div>
      <div class="col">
        <strong> {{ betSlip.winnings | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}} </strong>
      </div>
    </div>
    
    <div class="row border-top py-2 mt-2"
      *ngIf="coupon.status !== 'open' && coupon.status !== 'cancel' && coupon.status !== 'refund'">
      <div class="col-4 col-md-3">{{ "RACES.ODDS" | translate }}</div>
      <div class="col">
        <div class="columnList font-weight-bold">
          <div *ngFor="let betOdd of finalResults ;let i = index">
            <div class="row" *ngIf="betOdd?.isActive">
              <div class="col-6">
                {{ (betOdd.name ? betOdd.name : betOdd.type ) | bettingType | translate | capitalizeFirst }}
              </div>
              <div class="col-6">
                {{ betOdd.odd }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-end align-items-center my-3 px-2">
    <div class="col-auto mr-auto" *ngIf="coupon.status === 'open' && timeToStart>60">
      <button class="btn btn-outline-danger" (click)="cancelCoupon()" [disabled]="loadCancel">
        <i *ngIf="loadCancel" class="pi pi-spin pi-spinner text-warning mr-1" style="font-size: 1.1rem"></i>
        {{ "RACES.CANCEL_COUPON" | translate }}
      </button>
    </div>
    <div class="col-auto">
      <button *ngIf="printVisible() && coupon.status !== 'cancel'" class="btn btn-outline-secondary" (click)="print()">
        {{ "GENERAL.PRINT" | translate }}
      </button>
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" (click)="goToRace()">{{ "RACES.GO_TO_RACE" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-screen *ngIf="loadingModal"></app-loading-screen>

<app-bet-print id="content" *ngIf="!loadingModal" [isBettingSlipModal]="true" [data]="allData"></app-bet-print>